import FormMixin from 'mixins/FormMixin'

export default {
    mixins: [FormMixin],

    props: {
        locations: { type: Array, required: true },
    },

    computed: {
        locationOptions() {
            return [
                {
                    label: this.$t('forms.auth.schedule.microcopy.all_locations'),
                    value: 'all',
                },
            ].concat(this.locations)
        },

        currentLocationOption() {
            return this.locationOptions.find(({ value }) => value === this.currentLocationId)
        },
    },

    methods: {
        getRealLocationId(locationId) {
            return locationId === 'all' ? this.locations[0].value : locationId
        },

        getRealLocationIds(locationId) {
            return locationId === 'all' ? this.locations.map(({ value }) => value) : [locationId]
        },

        locationSchedule(locationId) {
            locationId = this.getRealLocationId(locationId)
            return (
                this.data.draftSchedule[locationId] || {
                    appointmentLength: undefined,
                    frequency: undefined,
                    days: Array(7).fill([]),
                }
            )
        },

        locationSlots(locationId, day) {
            return this.$get(this.locationSchedule(locationId), ['days', day])
        },

        locationSlotsByDate(locationId, date) {
            return this.$get(this.locationSchedule(locationId), ['values', date])
        },

        filledDays(locationId) {
            if (locationId === null) {
                return
            }
            return this.$get(this.locationSchedule(locationId), 'days').reduce((filledDays, day, index) => {
                if (day.length) {
                    filledDays.push(index)
                }
                return filledDays
            }, [])
        },

        /**
         * Collect the days of the week for which all availability slots are removed for specific location
         *
         * @param locationId
         * @param currentDay
         * @returns {*}
         */
        removedDays(locationId, currentDay) {
            return this.$get(this.locationSchedule(locationId), 'days').reduce((removedDays, day, index) => {
                if (!day.length && currentDay === index) {
                    removedDays.push(index)
                }
                return removedDays
            }, [])
        },

        slotsForDayPath(day) {
            return `days.${day}`
        },

        slotsForDatePath(date) {
            return `values.${date}`
        },

        discardDay(locationId, day, inAppliedSchedule = false) {
            this.changeLocationSchedule(
                {
                    path: this.slotsForDayPath(day),
                    value: [],
                },
                locationId,
                inAppliedSchedule,
            )
        },

        discardDraft(locationId, day) {
            const appliedValues = JSON.parse(JSON.stringify(this.data.appliedSchedule[Number(locationId) || 0].days[day]))
            const frequencyAppliedValue = this.data.appliedSchedule[Number(locationId)].frequency
            this.changeLocationSchedule(
                {
                    path: this.slotsForDayPath(day),
                    value: appliedValues,
                },
                locationId,
            )
            this.changeLocationSchedule(
                {
                    path: 'frequency',
                    value: frequencyAppliedValue,
                },
                locationId,
            )
        },

        discardDays(locationId, inAppliedSchedule = false, except = []) {
            for (let day = 0; day < 7; day++) {
                if (except.includes(day)) {
                    continue
                }

                this.discardDay(locationId, day, inAppliedSchedule)
            }
        },

        discardDate(locationId, datePath, inAppliedSchedule = false) {
            this.changeLocationSchedule(
                {
                    path: this.slotsForDatePath(datePath),
                    value: [],
                },
                locationId,
                inAppliedSchedule,
            )
        },

        discardDates(locationId, inAppliedSchedule = false, except = []) {
            const locationValues = this.data.draftSchedule[locationId].values

            for (const date of Object.keys(locationValues)) {
                if (except.includes(date)) {
                    continue
                }

                this.discardDate(locationId, date, inAppliedSchedule)
            }
        },

        changeAndApplyLocationSchedule(event, locationId) {
            this.changeLocationSchedule(event, locationId)
            this.changeLocationSchedule(event, locationId, true)
        },

        changeLocationSchedule({ path, value }, locationId, inAppliedSchedule = false) {
            this.getRealLocationIds(locationId).forEach((locationId) => {
                this.change({
                    path: inAppliedSchedule ? `appliedSchedule.${locationId}.${path}` : `draftSchedule.${locationId}.${path}`,
                    value,
                })
            })
        },
    },
}
